/**
 * ContinuousDocument Module Exports
 *
 * This file exports all components, utilities, and hooks for the ContinuousDocument editor.
 *
 * Main export is the ContinuousDocument component.
 * Other exports are available for advanced usage.
 */

// Main component - default export for backward compatibility
import ContinuousDocument from './ContinuousDocument';
export default ContinuousDocument;

// Named exports
export { default as ContinuousDocument } from './ContinuousDocument';
export { default as EditorToolbar } from './EditorToolbar';
export { default as ToolbarButton } from './ToolbarButton';

// Utilities
export {
  normalizeResizableImageNode,
  normalizeDocumentContent,
  unwrapCodeFence,
  looksLikeMarkdownTable,
  mdTableToJSON
} from './utils';

export {
  extractTableData,
  tableToMarkdown,
  tableToHTML,
  tableToJSON,
  tableToCSV,
  copyTableInFormat
} from './tableUtils';

// Hooks
export { useTextInsertion } from './hooks/useTextInsertion';

